var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-control", class: { error: _vm.showError } },
    [
      _c("label", [_vm._v(_vm._s(_vm.value.label))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "facet-input-field ranges",
          attrs: { "data-prefix": "$" }
        },
        [
          _c("input", {
            ref: "min",
            attrs: { type: "number", min: "0", placeholder: "From" },
            domProps: { value: _vm.value.min },
            on: {
              input: function($event) {
                return _vm.updateRangeFacet()
              }
            }
          }),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _c("input", {
            ref: "max",
            attrs: { type: "number", min: "0", placeholder: "To" },
            domProps: { value: _vm.value.max },
            on: {
              input: function($event) {
                return _vm.updateRangeFacet()
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm.showError
        ? _c("p", [
            _vm._v(
              "Please select a valid " + _vm._s(_vm.labelInLowerCase) + "."
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }